const DataProcessing = () => {
  const steps = [
    {
      title: 'Veri Toplama',
      description: 'Piyasa verisi API\'lerinden gerçek zamanlı olarak çekilir',
      metrics: ['500+ Hisse', '10+ Gösterge', 'Milyonlarca veri'],
    },
    {
      title: 'Ön İşleme',
      description: 'Veriler temizlenir, normalize edilir ve analiz için hazırlanır',
      metrics: ['Veri Temizleme', 'Normalizasyon', 'Özellik Çıkarımı'],
    },
    {
      title: 'Analiz',
      description: 'Teknik göstergeler hesaplanır ve makine öğrenimi modelleri çalıştırılır',
      metrics: ['Algoritmik Analiz', 'ML Modelleri', 'Patern Tanıma'],
    },
    {
      title: 'Karar Üretimi',
      description: 'Analiz sonuçları birleştirilerek ALIM-SATIM veya İZLE kararları üretilir',
      metrics: ['Karar Skoru', 'Güven Seviyesi', 'Risk Değerlendirmesi'],
    },
  ];

  return (
    <section className="py-32 bg-dark relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-emerald/5 via-transparent to-emerald/5"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-beige-light mb-6">
            Veri İşleme Süreci
          </h2>
          <p className="text-xl text-beige/70 max-w-3xl mx-auto">
            Ham piyasa verisinden anlamlı karara giden yol
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-dark-card border border-dark-border rounded-2xl p-8 h-full hover:border-emerald/30 transition-all">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 bg-emerald/10 rounded-lg flex items-center justify-center">
                    <span className="text-emerald font-bold text-lg">{index + 1}</span>
                  </div>
                  <h3 className="text-xl font-bold text-beige-light">{step.title}</h3>
                </div>
                
                <p className="text-beige/70 text-sm mb-6 leading-relaxed">
                  {step.description}
                </p>

                <div className="space-y-2">
                  {step.metrics.map((metric, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <i className="ri-check-line text-emerald text-sm"></i>
                      <span className="text-beige/50 text-xs">{metric}</span>
                    </div>
                  ))}
                </div>
              </div>

              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-0.5 bg-gradient-to-r from-emerald/50 to-transparent"></div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-20 bg-dark-card border border-emerald/20 rounded-2xl p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-beige-light mb-6">
                Sürekli Öğrenen Sistem
              </h3>
              <p className="text-beige/70 leading-relaxed mb-6">
                BAGA'nın makine öğrenimi modelleri, her gün piyasa verilerini analiz ederek kendini geliştirir. Geçmiş kararların performansı değerlendirilir ve algoritmalar optimize edilir.
              </p>
              <p className="text-beige/70 leading-relaxed">
                Bu sayede sistem, değişen piyasa koşullarına adapte olur ve karar kalitesi sürekli artar.
              </p>
            </div>

            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/d2563b48bef902fa57ce1c32980a048b.jpg"
                alt="Makine Öğrenimi"
                className="w-full h-auto rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataProcessing;
